import React from 'react';
import ReportFrame from '../ReportFrame';

export default class ClientDepositDetails extends React.Component {
  static defaultProps = {
    OpportunityId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Client Deposit Details'
          reportParams={reportParams}
          id='clientdepositdetails'
          name='clientdepositdetails'
          title='Client Deposit Details'
        />
      </div>
    );
  }
}
